module.exports = __webpack_public_path__ + "img/star-nebula-2.61c20d78.png";